import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Auth from '../components/Auth';
import MoreModal from '../components/Modal/MoreModal';
import SettingsModal from '../components/Modal/SettingsModal/index';
import { PaymentModal } from '../components/Modal/PaymentModal';
import { GeozonePage } from '../components/Modal/GeozonesModal/GeozoneCreatePage';

@connect(state => ({
  isAuthenticated: state.auth.isAuthenticated,
  moreModalOpened: state.modal.moreModalOpened,
  settingsModalOpened: state.modal.settingsModalOpened,
  paymentsModalOpened: state.modal.paymentsModalOpened,
  geozonesModalOpened: state.modal.createGeozoneOpened,
  settingsType: state.settings.settingsType,
  contracts: state.contracts.contracts,
  devices: state.devices.devices,
  currentLanguage: state.langs.currentLanguage
}))
@translate(['common'], { wait: true })
class App extends Component {
  componentWillReceiveProps(props) {
    if (props.location.pathname === '/rides') {
      document.body.classList.add('full-map-main');
    } else {
      document.body.classList.remove('full-map-main');
    }
  }

  componentDidUpdate() {
    if (this.props.moreModalOpened || this.props.settingsModalOpened || this.props.geozonesModalOpened) {
      document.body.classList.add('blur');
    } else {
      document.body.classList.remove('blur');
    }
    if (this.props.isAuthenticated === true) {
      setTimeout(() => document.body.classList.add('pace-done'), 500);
    } else {
      document.body.classList.remove('pace-done');
    }

    document.title = this.props.t('common:appName');
    document.documentElement.lang = this.props.currentLanguage;
  }

  render() {
    let registerNotFinished = !this.props.contracts.length;
    let needAuthRender = registerNotFinished || !this.props.isAuthenticated;
    if (this.props.isAuthenticated && this.props.devices.length) {
      registerNotFinished = false;
      needAuthRender = false;
    }
    return (
      <div>
        <div className="pace">
          <div className="pace-activity" />
        </div>
        { needAuthRender && <Auth registerNotFinished={registerNotFinished && this.props.isAuthenticated} /> }
        { this.props.moreModalOpened && <MoreModal /> }
        { this.props.paymentsModalOpened && <PaymentModal />}
        { this.props.settingsModalOpened && <SettingsModal type={this.props.settingsType} /> }
        { this.props.geozonesModalOpened && <GeozonePage /> }
        {!needAuthRender &&
        <div id="wrapper">
          <Header />
          <div className="main-wrapper">
            <Sidebar />
            <main className="main">
              { this.props.children }
            </main>
          </div>
        </div>
        }
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  moreModalOpened: PropTypes.bool,
  settingsModalOpened: PropTypes.bool,
  paymentsModalOpened: PropTypes.bool,
  settingsType: PropTypes.any,
  contracts: PropTypes.array,
  devices: PropTypes.array,
};

App.WrappedComponent.propTypes = {
  geozonesModalOpened: PropTypes.bool.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/Layout.js